module.exports = __webpack_public_path__ + "static/media/basel-37.69ab05a4.jpg";